document.addEventListener("DOMContentLoaded", () => {
  // Add has-sec-banner class to the body if .sec-top-banner class exists
    var mainTag = document.querySelector('main');
    if (mainTag) {
      // Find the first .shopify-section inside the main tag
      var firstShopifySection = mainTag.querySelector('.shopify-section');

      // Check if this first .shopify-section contains the .sec-top-banner class
      if (firstShopifySection && firstShopifySection.classList.contains('section-top-banner')) {
        document.body.classList.add('has-section-banner');
      }
    }

    // Image slide
    new Swiper("#custom_imgslider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1200,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    on: {
      init: function () {
        // autoplay video on first slide
        const firstSlide = this.slides[this.activeIndex];
        const video = firstSlide.querySelector("video");
        if (video) video.play();
      },
      transitionStart: function () {
        const videos = document.querySelectorAll("#custom_imgslider video");
        videos.forEach(function (video) {
          video.pause();
        });
      },
      transitionEnd: function () {
        const activeSlide = this.slides[this.activeIndex];
        const activeVideo = activeSlide.querySelector("video");

        if (activeVideo) {
          activeVideo.play();
          this.autoplay.stop();

          activeVideo.onended = () => {
            this.slideNext();
            this.autoplay.start();
          };
        }
      }
    }
  });

  // Most popular slide
  var swiper = new Swiper("#mostpopular_slide", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 15,
  speed: 1200,
  // freeMode: true,   

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    enabled: true
  },

  breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
        navigation: {
          enabled: false
        }
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 25,
        navigation: {
          enabled: false
        },
        pagination: {
          enabled: false
        }
      }
    }
  });

 // Olfactive popular slide
  var swiper = new Swiper("#olfacpopular_slide", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 15,
  speed: 1200,
  // freeMode: true,   

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    enabled: true
  },

  breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
        navigation: {
          enabled: false
        }
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 25,
        navigation: {
          enabled: false
        },
        pagination: {
          enabled: false
        }
      }
    }
});

// Archive Entries Slides
var swiper = new Swiper("#archive_entslides", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  freeMode: true,   

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    enabled: false
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    enabled: false
  },

  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        navigation: {
          enabled: false
        }
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 25,
        navigation: {
          enabled: false
        },
        pagination: {
          enabled: false
        }
      }
    }
});


  //-------mega menu desktop slider-----------
const sliders = document.querySelectorAll('.mega-swiper');
if (!sliders.length) return;

sliders.forEach((slider) => {
  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 15,
    speed: 800,
    freeMode: true, 

    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    },

    pagination: {
      el: slider.querySelector('.swiper-pagination'),
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        navigation: false,
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
      },
      1200: {
        slidesPerView: 3.2,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
        pagination: false,
      },
    },
  });
});

});


// Get Header Height
function updateHeaderHeight() {
  const headerBar = document.querySelector('.header-wrapper');
  if (headerBar) {
    const height = headerBar.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }
}
document.addEventListener("DOMContentLoaded", function() {
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});


